const licenseUsageNames = ["projects", "tenants", "targets", "machines", "users", "tasks", "task cap"] as const;
const usageNameLookup = new Set<string>(licenseUsageNames);
type KnownLicenseUsageName = (typeof licenseUsageNames)[number];
export function isKnownLicenseUsageName(name: string): name is KnownLicenseUsageName {
    const potentialUsageName = name.toLowerCase();
    if (!potentialUsageName) {
        return false;
    }
    return usageNameLookup.has(potentialUsageName);
}
export function getKnownLicenseUsageNames(): typeof licenseUsageNames {
    return [...licenseUsageNames];
}
export function toKnownLicenseUsageName(name: string): KnownLicenseUsageName | undefined {
    const potentialName = name.toLowerCase();
    if (isKnownLicenseUsageName(potentialName)) {
        return potentialName;
    }
    return undefined;
}
